import { CalendarEvent } from '../CalendarEvent';

export class ProviderCalendarEvent extends CalendarEvent {
  protected externalLink: string;
  protected externalID: string;

  public getExternalLink(): string {
    return this.externalLink;
  }

  public setExternalLink(externalLink: string): this {
    this.externalLink = externalLink;
    return this;
  }

  public getExternalID(): string {
    return this.externalID;
  }

  public setExternalID(externalId: string): this {
    this.externalID = externalId;
    return this;
  }

  public hydrate(data: any) {
    this.externalID = data.externalID;
    this.externalLink = data.externalLink;

    return super.hydrate(data);
  }
}
